import { Component, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { ResizableGridRowComponent } from './resizable-grid-row/resizable-grid-row.component';

@Component({
    selector: 'app-resizable-grid',
    template: `
    <div class="resizable-grid">
      <ng-content></ng-content>
    </div>
  `,
    styles: [`
    .resizable-grid {
      position: relative;
      width: 100%;
      height: 100%;
    }
  `],
    standalone: false
})
export class ResizableGridComponent implements AfterContentInit {
  @ContentChildren(ResizableGridRowComponent) rows!: QueryList<ResizableGridRowComponent>;

  ngAfterContentInit() {
    this.rows.forEach((row, index) => {
      row.index = index;
      row.resized.subscribe((data: {index: number, newHeight: number}) => this.onRowResized(data));
    });
  }

  onRowResized(data: {index: number, newHeight: number}) {
    const { index, newHeight } = data;
    const rowArray = this.rows.toArray();
    const currentRow = rowArray[index];
    const nextRow = rowArray[index + 1];

    if (!nextRow) return; // Can't resize the last row

    const currentHeight = currentRow.height;
    const nextHeight = nextRow.height;
    const totalHeight = currentHeight + nextHeight;

    const diff = newHeight - currentHeight;

    // Check if the next row would go below its minimum height
    if (nextHeight - diff < nextRow.minHeight) {
      // Adjust the new height to respect the minimum height of the next row
      const maxChange = nextHeight - nextRow.minHeight;
      currentRow.height = currentHeight + maxChange;
      nextRow.height = nextRow.minHeight;
    } else {
      currentRow.height = newHeight;
      nextRow.height = totalHeight - newHeight;
    }

    currentRow.updatePosition();
    nextRow.top = currentRow.top + currentRow.height;
    nextRow.updatePosition();

    // Update all subsequent rows' positions
    for (let i = index + 2; i < rowArray.length; i++) {
      rowArray[i].top = rowArray[i - 1].top + rowArray[i - 1].height;
      rowArray[i].updatePosition();
    }
  }
}
